<div class="trinka_cloud_wrap">
    <div id="particles-js"></div>
    <div class="professional_header">
        <div class="container">
            <div class="row">
                <div class="col-lg-8">
                    <div class="professional_heading">
                        <h1>Enago專業英文論文編修服務</h1>
                        <img src="../../../assets/images/proofreaional_poweredby_img.png" alt="">
                    </div>
                    <div class="professional_contents">
                        <p>Trinka能協助您消除文稿中的語言錯誤，有利您投稿期刊。期刊在審稿稿件時，看的不只是語言，更重視文章結構和邏輯的強度、研究貢獻、方法論健全等其他面向。 </p>
                        <p>英論閣的論文編修服務不只修正文法和語言上的錯誤，同領域的英文母語博碩士學科專家將檢查文稿的邏輯、結構、是否符合期刊的投稿規定。另外我們也提供投稿前同儕審閱，讓您先行補強文稿的弱點，增加投稿成功機會。</p>
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="professional_img">
                        <img src="../../../assets/images/searching_for_proofreading.png" alt="">
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="profressional_pricing">
        <div class="profressional_pricing_overlay"></div>
        <div class="container">
            <div class="row">
                <div class="col-lg-4">
                    <div class="profressional_cards">
                        <div class="prof_card_heading">
                            <h2><img src="../../../assets/images/Proofreading_icons.png" alt=""> 標準編修</h2>
                            <p>適合已被期刊接受，<br class="removeBr"/>只需作文法和語言修改的文稿。</p>
                        </div>
                        <div class="prof_card_bodysection">
                            <ul>
                                <li>文法句法檢查</li>
                                <li>標點符號使用</li>
                                <li>拼寫和時態</li>
                                <li>用語一致</li>
                                <li>名編修師修改</li>
                                <li>年內免費無限編輯答疑</li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="col-lg-4 paddingSectionRemove">
                    <div class="profressional_cards">
                        <div class="prof_card_heading">
                            <h2><img src="../../../assets/images/CopyEditing_Icon.png" style="width: 40px;" alt=""> 標準編修</h2>
                            <p>提供高品質的英文編輯，確保語法、<br class="removeBr"/>句構和語境正確呈現。</p>
                        </div>
                        <div class="prof_card_bodysection">
                            <div class="additional_services">
                                <p><img src="../../../assets/images/Proofreading_icons.png" alt="" style="width: 20px;"> 包括標準編修 的所有服務項目</p>
                                <span><i class="fa fa-plus"></i></span>
                            </div>
                            <ul>
                                <li>寫作提升（清晰度和可讀性）</li>
                                <li>選字用語和句構調整</li>
                                <li>技術用語準確</li>
                                <!-- <li>Sentence Structure</li>
                                <li>Basic Formatting</li> -->
                                <li>10%字數縮減</li>
                                <li>兩名同領域英文母語編修師修改</li>
                                <li><strong>1頁</strong> 英文原稿品質測評卡
                                    <span class="prof_tooltipSection"><img src="../../../assets/images/info.svg" alt="info icon"></span>
                                    <div class="tooltiptext_section CopyEditingSection">
                                        <p>詳細的分析報告，給予您學術寫作上的建議</p>
                                    </div>
                                </li>
                                <li><strong>120天</strong> 文稿重修* 
                                    <span class="prof_tooltipSection"><img src="../../../assets/images/info.svg" alt="info icon"></span>
                                    <div class="tooltiptext_section oneTowntyTooltip">
                                        <p>無限次重修稿件至您滿意為止</p>
                                        <img src="../../../assets/images/PaperIcons.png" alt="">
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="col-lg-4">
                    <div class="profressional_cards">
                        <div class="prof_card_heading">
                            <h2> <img src="../../../assets/images/SubstantiveEditing_Icon.png"  style="width: 40px;" alt=""> 高階編修</h2>
                            <p>提供超越文句層面的編輯，<br class="removeBr"/>以加強邏輯和各段落的連接，優化結構和內容組織。</p>
                        </div>
                        <div class="prof_card_bodysection">
                            <div class="additional_services">
                                <p><img src="../../../assets/images/CopyEditing_Icon.png" style="width: 30px;" alt=""> 包括標準編修的所有服務項目</p>
                                <span><i class="fa fa-plus"></i></span>
                            </div>
                            <ul>
                                <li>內容整體呈現</li>
                                <li>邏輯與論證流暢度</li>
                                <li>文稿結構強化</li>
                                <!-- <li>Manuscript Structure</li>
                                <li>Advanced Formatting & Presentation</li> -->
                                <li>20%字數縮減</li>
                                <li>投稿說明信</li>
                                <li><strong>4頁</strong> 英文原稿品質測評卡t <span class="prof_tooltipSection"><img src="../../../assets/images/info.svg" alt="info icon"></span>
                                    <div class="tooltiptext_section SubstantiveSection">
                                        <p>詳細的分析報告，給予您學術寫作上的建議</p>
                                    </div>                                
                                </li>
                                <li><strong>365天</strong> 文稿重修 <span class="prof_tooltipSection"><img src="../../../assets/images/info.svg" alt="info icon"></span>
                                    <div class="tooltiptext_section ThreedayTooltip">
                                        <p>無限次重修稿件至您滿意為止</p>
                                        <img src="../../../assets/images/PaperIcons.png" alt="">
                                    </div>
                                </li>
                                <li>
                                    <strong>365天</strong> 退稿金鐘罩* <span class="prof_tooltipSection"><img src="../../../assets/images/info.svg" alt="info icon"></span>
                                    <div class="tooltiptext_section shieldTooltip">
                                        <p>協助依期刊審閱意見修改文稿</p>
                                        <img src="../../../assets/images/Rejections_Shield.png" alt="" style="margin-left: -20px;">
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="col-sm-12">
                    <div class="paidSection">
                        <p>*選購服務</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>